import indowWindowStyles from '../../../../shared/styles/infowindow.style';
import { InfowindowContentBuilder } from '../../../../shared/utils/infoWindowContentBuilder';
import { InfowindowBuilder } from '../../../../shared/utils/infowindowBuilder';
import {
  InfoWindowRealtyTransactions,
  RealtyTransactionInfoWindow,
} from '../types';

const infoWindowRealtyTransactionsContent = (
  payload: InfoWindowRealtyTransactions,
  mr: string
) => {
  const {
    building_name,
    address,
    realties_amount,
    units_traded,
    construction_pattern,
    construction_year,
    use_type,
  } = payload;

  const formattingWord = (word: string) => {
    const formattedWord =
      word.charAt(0).toUpperCase() + word.toLowerCase().slice(1);
    return formattedWord;
  };

  const dynamicStyle = (word: string) => {
    if (word.length > 40) {
      return '15px';
    }
    return '0';
  };

  const header = `<h6 class="header--title" data-cy="IWBuildingName${mr}">${building_name}</h6>`;

  const body = `<p class="header--address" data-cy="IWAddress${mr}">${address}</p>

  <div class="body-container--info">
      <div class="info-container">
      <p class="body-container--info-key" data-cy="IWUnitTotalKey${mr}"><strong>Total de unidades: </strong></p>
      <p class="body-container--info-value" data-cy="IWUnitTotalValue${mr}">${realties_amount}</p>
      </div>
      <div class="info-container">
      <p class="body-container--info-key" data-cy="IWRealtyTypeKey${mr}"><strong>Tipo de imóvel: </strong></p>
      <p class="body-container--info-value" data-cy="IWRealtyTypeValue${mr}">${formattingWord(
    construction_pattern
  )}</p>
      </div>
      <div class="info-container">
      <p class="body-container--info-key" data-cy="IWUseTypeKey${mr}"><strong>Tipo de uso: </strong></p>
      <p class="body-container--info-value" data-cy="IWUseTypeValue${mr}">${formattingWord(
    use_type
  )}</p>
      </div>
  </div>
  <div class="body-container--info">
      <div class="info-container">
      <p class="body-container--info-key" data-cy="IWUnitsTradedKey${mr}"><strong>Unidades transacionadas: </strong></p>
      <p class="body-container--info-value" data-cy="IWUnitsTradedValue${mr}">${units_traded}</p>
      </div>
      <div class="info-container">
      <p class="body-container--info-key" data-cy="IWConstructionYearKey${mr}"><strong>Ano da construção: </strong></p>
      <p class="body-container--info-value" data-cy="IWConstructionYearValue${mr}">${construction_year}</p>            
      </div>
  </div>`;

  const footer = `
  <button class="infowindow-button" id="IWButton" ${mr}" data-cy="IWBuildingDetailsButton${mr}">Ver indicadores</button>
  `;

  return new InfowindowContentBuilder({
    header,
    body,
    footer,
  });
};

const infoWindowRealtyTransactions = ({
  payload,
  mr,
  marker,
  map,
  actions,
}: RealtyTransactionInfoWindow) => {
  return new InfowindowBuilder({
    content: [infoWindowRealtyTransactionsContent(payload, mr)],
    marker: marker as google.maps.Marker,
    map,
    actions,
    style: indowWindowStyles,
  });
};

export default infoWindowRealtyTransactions;
